import React from 'react'

import NavMenuItem from './NavMenuItem'

export default function SmartMenuList(props) {

  const { items, checks, clients, locations, isWorkLocationAssigned, cptTotal, ...p } = props;

  return (
    <ul {...p}>
      {items.map((item) => {
        return <NavMenuItem item={item} key={item._id} checks={checks} isWorkLocationAssigned={isWorkLocationAssigned} clients={clients} locations={locations} cptTotal={cptTotal}/>
      })}
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/components/navigation/components/NavMenuList.js